<template>
  <div class="customer-editor">

    <div class="butler-note-wrap">

      <el-tabs v-model="type" @tab-click="clickTab()">
        <el-tab-pane label="客户日常信息" name="daily">

          <!-- 客户日常信息 start -->
          <div style="margin-bottom: 10px;">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="daily.dialogVisible = true">添加</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="batchDelete()">批量删除</el-button>
          </div>

          <el-table :data="daily.data" border style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column prop="title" label="日常信息" width="180" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" width="180" align="center"></el-table-column>
            <el-table-column prop="operator" label="登记人" align="center"></el-table-column>
            <el-table-column label="登记时间" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.create_time)}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteItem(scope.row.id)"></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block pagination">
            <el-pagination background layout="prev, pager, next" :total="daily.pageTotal" :page-size="daily.pageSize" :current-page="daily.page" @current-change="changePage"></el-pagination>
          </div>

          <el-dialog title="添加客户日常信息" :visible.sync="daily.dialogVisible" append-to-body>

            <el-row :gutter="0">
              <el-col :span="22">

                <el-form :model="daily.form" :rules="daily.rules" :label-width="width" ref="daily">
                  <el-form-item label="活动名称" prop="title">
                    <el-select v-model="daily.form.title" placeholder="请选择或输入活动名称" filterable allow-create>
                      <el-option label="客户动态" value="客户动态"></el-option>
                      <el-option label="重要情况" value="重要情况"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="daily.form.remark" rows="5"></el-input>
                  </el-form-item>
                </el-form>


              </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
              <el-button @click="daily.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('daily')" :loading="daily.loading">确 定</el-button>
            </div>

          </el-dialog>
          <!-- 客户日常信息 end -->

        </el-tab-pane>
        <el-tab-pane label="访客登记" name="visitor">

          <!-- 访客登记 start -->
          <div style="margin-bottom: 10px;">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="visitor.dialogVisible = true">添加</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="batchDelete()">批量删除</el-button>
          </div>

          <el-table :data="visitor.data" border style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column prop="name" label="来访人" width="" align="center"></el-table-column>
            <el-table-column prop="visit_time" label="到访时间" width="" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.visit_time)}}
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="到访事由" align="center"></el-table-column>
            <el-table-column prop="leave_time" label="离开时间" width="" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.leave_time)}}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="" align="center"></el-table-column>
            <el-table-column prop="operator" label="登记人" width="" align="center"></el-table-column>
            <el-table-column label="登记时间" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.create_time)}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteItem(scope.row.id)"></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block pagination">
            <el-pagination background layout="prev, pager, next" :total="visitor.pageTotal" :page-size="visitor.pageSize" :current-page="visitor.page" @current-change="changePage"></el-pagination>
          </div>

          <el-dialog title="添加访客登记信息" :visible.sync="visitor.dialogVisible" append-to-body>

            <el-row :gutter="0">
              <el-col :span="22">

                <el-form :model="visitor.form" :rules="visitor.rules" :label-width="width" ref="visitor">
                  <el-form-item label="来访人" prop="name">
                    <el-input v-model="visitor.form.name" placeholder="请输入来访人姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="到访时间" prop="visit_time">
                    <el-date-picker v-model="visitor.form.visit_time" type="datetime" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="离开时间" prop="leave_time">
                    <el-date-picker v-model="visitor.form.leave_time" type="datetime" placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="到访事由" prop="reason">
                    <el-input type="textarea" v-model="visitor.form.reason" rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="visitor.form.remark" rows="4"></el-input>
                  </el-form-item>
                </el-form>

              </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
              <el-button @click="visitor.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('visitor')" :loading="visitor.loading">确 定</el-button>
            </div>

          </el-dialog>
          <!-- 访客登记 end -->

        </el-tab-pane>
        <el-tab-pane label="兴趣爱好" name="interest">

          <!-- 兴趣爱好 start -->
          <div style="margin-bottom: 10px;">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="interest.dialogVisible = true">添加</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="batchDelete()">批量删除</el-button>
          </div>

          <el-table :data="interest.data" border style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column prop="title" label="兴趣爱好" width="180" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" width="180" align="center"></el-table-column>
            <el-table-column prop="operator" label="登记人" align="center"></el-table-column>
            <el-table-column label="登记时间" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.create_time)}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteItem(scope.row.id)"></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block pagination">
            <el-pagination background layout="prev, pager, next" :total="interest.pageTotal" :page-size="interest.pageSize" :current-page="interest.page" @current-change="changePage"></el-pagination>
          </div>

          <el-dialog title="添加兴趣爱好信息" :visible.sync="interest.dialogVisible" append-to-body>

            <el-row :gutter="0">
              <el-col :span="22">

                <el-form :model="interest.form" :rules="interest.rules" :label-width="width" ref="interest">
                  <el-form-item label="兴趣爱好" prop="title">
                    <el-select v-model="interest.form.title" placeholder="请选择或输入兴趣爱好" filterable allow-create>
                      <el-option label="音乐" value="音乐"></el-option>
                      <el-option label="上网" value="上网"></el-option>
                      <el-option label="运动" value="运动"></el-option>
                      <el-option label="旅游" value="旅游"></el-option>
                      <el-option label="绘画" value="绘画"></el-option>
                      <el-option label="文学" value="文学"></el-option>
                      <el-option label="收藏" value="收藏"></el-option>
                      <el-option label="摄影" value="摄影"></el-option>
                      <el-option label="棋牌" value="棋牌"></el-option>
                      <el-option label="舞蹈" value="舞蹈"></el-option>
                      <el-option label="书法" value="书法"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="interest.form.remark" rows="5"></el-input>
                  </el-form-item>
                </el-form>


              </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
              <el-button @click="interest.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('interest')" :loading="interest.loading">确 定</el-button>
            </div>

          </el-dialog>
          <!-- 兴趣爱好 end -->

        </el-tab-pane>
        <el-tab-pane label="其他需求" name="other">

          <!-- 其他需求 start -->
          <div style="margin-bottom: 10px;">
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="other.dialogVisible = true">添加</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="batchDelete()">批量删除</el-button>
          </div>

          <el-table :data="other.data" border style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column prop="title" label="兴趣爱好" width="180" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" width="180" align="center"></el-table-column>
            <el-table-column prop="operator" label="登记人" align="center"></el-table-column>
            <el-table-column label="登记时间" align="center">
              <template slot-scope="scope">
                {{timeFormat(scope.row.create_time)}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteItem(scope.row.id)"></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block pagination">
            <el-pagination background layout="prev, pager, next" :total="other.pageTotal" :page-size="other.pageSize" :current-page="other.page" @current-change="changePage"></el-pagination>
          </div>

          <el-dialog title="添加其他需求信息" :visible.sync="other.dialogVisible" append-to-body>

            <el-row :gutter="0">
              <el-col :span="22">

                <el-form :model="other.form" :rules="other.rules" :label-width="width" ref="other">
                  <el-form-item label="需求" prop="title">
                    <el-select v-model="other.form.title" placeholder="请选择或输入需求" filterable allow-create>
                      <el-option label="家政" value="家政"></el-option>
                      <el-option label="购物" value="购物"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="other.form.remark" rows="5"></el-input>
                  </el-form-item>
                </el-form>


              </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
              <el-button @click="other.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('other')" :loading="other.loading">确 定</el-button>
            </div>

          </el-dialog>
          <!-- 其他需求 end -->

        </el-tab-pane>
      </el-tabs>

    </div>

  </div>
</template>

<script>

  import Common from './common.js'

  export default {
    name: "butler-note-editor",
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        loading: false,
        form: {},
        type: 'daily',

        daily: {
          dialogVisible: false,
          data: [],
          form: {
            title: '',
            remark: ''
          },
          selection: [],
          rules: {
            title: [
              { required: true, message: '请输入日常信息', trigger: 'change' },
            ],
          },
          pageTotal: 0,
          pageSize: 10,
          page: 1,
          loading: false,
        },

        visitor: {
          dialogVisible: false,
          data: [],
          form: {
            name: '',
            visit_time: '',
            leave_time: '',
            reason: '',
            remark: '',
          },
          selection: [],
          rules: {
            name: [{ required: true, message: '请输入到访人姓名', trigger: 'blur' }],
            visit_time: [{ required: true, message: '请输入到访时间', trigger: 'change' }],
            reason: [{ required: true, message: '请输入到访事由', trigger: 'blur' }],
            leave_time: [{ required: true, message: '请输入离开时间', trigger: 'change' }],
          },
          pageTotal: 0,
          pageSize: 10,
          page: 1,
          loading: false,
        },

        interest: {
          dialogVisible: false,
          data: [],
          form: {
            title: '',
            remark: ''
          },
          selection: [],
          rules: {
            title: [
              { required: true, message: '请输入兴趣爱好', trigger: 'change' },
            ],
          },
          pageTotal: 0,
          pageSize: 10,
          page: 1,
          loading: false,
        },

        other: {
          dialogVisible: false,
          data: [],
          form: {
            title: '',
            remark: ''
          },
          selection: [],
          rules: {
            title: [
              { required: true, message: '请输入其他需求', trigger: 'change' },
            ],
          },
          pageTotal: 0,
          pageSize: 10,
          page: 1,
          loading: false,
        },

      }
    },
    mounted() {
      console.log('butler-note mounted')
      this.getData()
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {

        }
      },
    },
    methods: {
      getData() {
        this.$myhttp.get('admin/Customer/getButlerNote', {params: {type: this.type, page: this[this.type].page, pageSize: this[this.type].pageSize, customer_id: this.id}}).then(backdata => {
          let res = backdata.data
          this[this.type].data = res.data
          this[this.type].pageTotal = res.total
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            let data = Object.assign({customer_id: this.id, operator: window.localStorage.getItem('login')}, this[this.type].form)
            this[this.type].loading = true

            this.$myhttp.post('admin/Customer/saveButlerNote?type=' + formName, data).then(backdata => {
              let res = backdata.data

              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })

              this.$refs[formName].resetFields();
              this[this.type].dialogVisible = false
              this.getData()
              this[this.type].loading = false

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });
      },
      timeFormat: Common.timeFormat,
      deleteItem(id) {
        this.$confirm('确定要删除选中记录?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
          this.$myhttp.post('admin/Customer/deleteButlerNote?type=' + this.type, {id: id}).then(backdata => {
            let res = backdata.data
            this.$message({
              message: res.msg,
              type: res.code == 200 ? 'success' : 'error'
            })
            this.getData()
          })
        })
      },
      batchDelete() {
        let id = this[this.type].selection

        if(id.length == 0) {
           this.$alert('请先勾选要删除的记录!', '提示', { type: 'warning'})
           return false
        }

        this.deleteItem(id.join(','))
      },
      selectionChange(val) {
        this[this.type].selection = val.map(item => item.id)
      },
      changePage(val) {
        this[this.type].page = val
        this.getData()
      },
      clickTab() {
        this.getData()
      }
    }
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";

  .butler-note-wrap {
    padding: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/butler-note-editor.vue